import React from "react";
import { toKebabCase } from "@qlik/qlik/src/lib/utils";
import ResourceCard from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Resource_Card";
import ResourceNoImage from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Resource_No_Image";
import Cta from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Cta";
import { mainMenu } from "@qlik/qlik/src/lib/menu";
// eslint-disable-next-line import/no-extraneous-dependencies
import { get } from "lodash";

/**
 * SubmenuLayoutSeven renders the right hand side of a main menu drop down, with
 * left: ResourceCard, right: ResourceNoImage[], Cta
 * e.g. learn > blog
 */
const SubmenuLayoutSeven = ({ data: subItems, layoutType, layoutId, className = "", deviceType = "desktop" }) => {
    const allowedLayoutMap = get(mainMenu, `[${layoutType}]`);
    const allowedComponents = Object.keys(allowedLayoutMap);
    const layoutClass = toKebabCase(layoutType);

    const typeOneComponents = subItems?.find((subItem) => subItem.itemName === allowedComponents[0]);
    const typeTwoComponents = subItems?.filter((subItem) => subItem.itemName === allowedComponents[1]);
    const typeThreeComponents = subItems?.find((subItem) => subItem.itemName === allowedComponents[2]);

    return (
        <div
            className={`submenu-level-3 submenu--${layoutClass} ${className} gap-15 xl:py-15 xl:h-full relative`}
            data-parent={`${layoutClass}-${layoutId}`}
            data-device={`${deviceType}`}
        >
            <div className="-z-1 absolute max-xl:hidden bg-dropdownImage bg-contain -bottom-76 -right-283.75 w-455 h-97.75" />
            <div className="max-xl:mb-15 flex-[0_0_370px]">
                <ResourceCard data={typeOneComponents} />
            </div>
            <div className="flex-[0_0_380px] flex flex-col">
                <div>
                    {typeTwoComponents && (
                        <ul className="">
                            {typeTwoComponents.map((item) => (
                                <li key={item?.id}>
                                    <ResourceNoImage data={item} />
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div className="mt-auto">{typeThreeComponents && <Cta data={typeThreeComponents} />}</div>
            </div>
        </div>
    );
};

export default SubmenuLayoutSeven;
